export type IMaskPhoneNumbers = IDCA.IGenericFunc;

export function _maskPhoneNumbers(): void {
  $('input.phone-field').each((_, input) => {
    const $input = $(input);
    const mask = $input.data('field-mask') || window.DexeroCoreApp.userOptions.phoneMask;
    ($input as any).mask(mask);
  });
}
